import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Bootstrap harus dimuat lebih dulu supaya style.css bisa menimpanya.
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
